import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/en/services/quality-assurance/annual-product-review-apr-product-quality-review-pqr")({
  beforeLoad: () => { throw redirect({ to: "/en/services/quality-assurance/qa-consultancy-apr-pqr", statusCode: 301 }); },
});
